import { render, staticRenderFns } from "./AddStatInspItem.vue?vue&type=template&id=023a1431"
import script from "./AddStatInspItem.vue?vue&type=script&lang=js"
export * from "./AddStatInspItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports